import React from 'react';
import Kanban from '../components/Kanban';

const Board = () => {
    return (
        <div>
            <Kanban />
        </div>
    );
};

export default Board;
